import { Card, Row, Col, Button } from "react-bootstrap";
import { useState, useCallback, useContext } from "react";
import { useSelector } from "react-redux";
import { ProfileContext } from "pages/Profile";
import { toast } from "react-toastify";

export default function PasswordReset() {
  const { profile, setProfile } = useContext(ProfileContext)
  const { user: authUser } = useSelector(x => x.auth)

  const url = process.env.REACT_APP_URL

  const [saveLoading, setSaveLoading] = useState(false)
  const [emailSaving, setEmailSaving] = useState(false)
  const [editingEmail, setEditingEmail] = useState(false)
  const [emailDraft, setEmailDraft] = useState(profile.email || '')

  const canEditEmail = authUser.user.acl === 'Officer' || authUser.user._id === profile._id;

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setSaveLoading(true);
    try {
      const response = await fetch(`${url}/users/reset`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: profile.email })
      })
      const result = await response.json();
      const response2 = await fetch(`${process.env.REACT_APP_MAILSERVER}/html`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify({
          appMailUser: process.env.REACT_APP_MAILUSER,
          appMailPass: process.env.REACT_APP_MAILPASS,
          // from: 'brnotoastmasterspresident@gmail.com',
          toList: profile.email,
          subject: `${process.env.REACT_APP_TITLE} password reset`,
          html: `
              <h3>${process.env.REACT_APP_TITLE} password reset</h3>
              <p>You are receiving this because you (or someone else) have requested the reset of the password for your account.</p>
              <p>If you did not request this, please ignore this email and your password will remain unchanged.</p>
              <p>Please click on the following link:</p>
              <p><a href="${window.location.protocol}//${window.location.host}/reset/${result.resetToken}">Click here</a></p>
              <p>or copy and paste in a new tab of your web browser the following link to complete the process: ${window.location.protocol}//${window.location.host}/reset/${result.resetToken}</p>
              <p><small style="color:red">the link is valid only one hour since the request was made</small></p>
              `
        })
      })
      const result2 = await response2.json();
      if (result2.code === 200) {
        console.log('email sent')
        toast.success('Email with password reset link was sent', { position: 'bottom-left' });
      }
      else {
        console.log('email not sent')
        toast.error('Something went wrong, please try again later.', { position: 'bottom-left' });
      }
    }
    catch (error) {
      console.log(error)
      toast.error(`Something went wrong: ${error}`, { position: 'bottom-left' });
    }
    setSaveLoading(false);
  }, [profile.email, url])

  const handleEmailSave = useCallback(async () => {
    if (!canEditEmail) return;
    const nextEmail = String(emailDraft || '').trim();
    if (!nextEmail || nextEmail === profile.email) {
      setEditingEmail(false);
      setEmailDraft(profile.email || '');
      return;
    }

    setEmailSaving(true);
    try {
      const response = await fetch(`${url}/users/${profile._id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`
        },
        body: JSON.stringify({ email: nextEmail })
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result?.Error || 'Failed to update email');
      }
      setProfile(prev => ({ ...prev, ...result, avatarUrl: prev?.avatarUrl || result?.avatarUrl || null, avatar: prev?.avatar || result?.avatar || null }));
      toast.success('Email updated successfully', { position: 'bottom-left' });
      setEditingEmail(false);
    } catch (error) {
      toast.error('Failed to update email', { position: 'bottom-left' });
      setEmailDraft(profile.email || '');
    } finally {
      setEmailSaving(false);
    }
  }, [canEditEmail, emailDraft, profile.email, profile._id, url, authUser.token, setProfile]);

  return (
    <Card className="mt-3 mb-3 user-card settings-card meetings-mock-card-shell meetings-page-card">
      <Card.Header className="settings-card-header">
        <Row className="mt-2 mb-2"><Col>Sign-in Method</Col></Row>
      </Card.Header>
      <Card.Body className="settings-card-body">
        <div className="settings-inline-list">
          <div className="settings-inline-row settings-inline-row--force-inline">
            <span className="settings-inline-label">Email account</span>
            {editingEmail ? (
              <input
                type="email"
                className="form-control settings-inline-input"
                autoFocus
                value={emailDraft}
                onChange={(e) => setEmailDraft(e.target.value)}
                onBlur={handleEmailSave}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleEmailSave();
                  }
                  if (e.key === 'Escape') {
                    e.preventDefault();
                    setEditingEmail(false);
                    setEmailDraft(profile.email || '');
                  }
                }}
                disabled={emailSaving}
              />
            ) : (
              <button
                type="button"
                className="settings-inline-value"
                onClick={() => canEditEmail && setEditingEmail(true)}
                disabled={!canEditEmail || emailSaving}
              >
                {profile.email || 'N/A'}
              </button>
            )}
          </div>


          {(authUser.user.acl === 'Officer' || authUser.user._id === profile._id) && (
            <div className="settings-inline-row settings-inline-row--force-inline">
              <span className="settings-inline-label">Password reset via link in email</span>
              {saveLoading ? (
                <span className="settings-inline-static">Sending email for password reset...</span>
              ) : (
                <Button variant="primary" className="settings-action-btn settings-action-btn--fit" onClick={handleSubmit}>
                  Change password
                </Button>
              )}
            </div>
          )}
        </div>
      </Card.Body>
    </Card >
  )
}